import React, { Component } from "react";
import { connect } from "react-redux";
import { getItems, deleteItem, increaseItem, decreaseItem, getItemsById } from "../../actions/armWrestlersActions";
import PropTypes from "prop-types";
import Axios from "axios";
import {
  Jumbotron,
  Button,
  Table,
  Form,
  Input,
  FormGroup,
} from 'reactstrap';
class RequestsList extends Component {
  state = {
    email: "",
    tableVisible: false,
    tableData: []
  }

  static propTypes = {
    isAuthenticated: PropTypes.bool
  }

  // componentDidMount() {
  //   this.props.getItems();
  // }

  handleValidSubmit = (e) => {
    e.preventDefault();
    console.log("handleValidSubmit");

    this.props.getItemsById(this.state.email);

    // Axios
    //   .post(`/api/userInformation/request/${this.state.email}`)
    //   .then(res => {
    //     console.log(res.data)
    //     this.setState({ tableData: res.data })
    //   })
  }
  onDeleteClick = id => {
    let confirm = window.confirm('Are you sure you want to delete this request?');
    if (confirm) {
      Axios
        .get(`/api/userInformation/request-delete/${id}`)
        .then((res) => {
          console.log(res.data)
          document.getElementById('submit-button').click()
        })
        .catch(err => {
          alert("Error while deleting .")
        })
    }
  }

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }
  render() {

    const { items } = this.props.item;
    return (
      <div>
        {/* <Container className="themed-container" fluid="sm">
          <Row>
            <Col>
            <Card body inverse style={{ backgroundColor: '#343a40', borderColor: '#343a40' }}>
              <CardHeader>Requests</CardHeader>
              <CardBody> */}
        <div>

          <Form inline onSubmit={this.handleValidSubmit}>
            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
              <Input type="email" name="email" id="email" placeholder="Email" onChange={this.onChange} value={this.state.email} />
              <Button color="dark" style={{ marginLeft: "1rem" }} id="submit-button" > Submit </Button>
            </FormGroup>
          </Form>

        </div>
        <div>
          <Table striped responsive className="mt-3">
            <thead>
              <tr>
                <th>Site Name</th>
                <th>Exam Type</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Expire Date</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => {
                return (
                  <tr key={item._id}>
                    <th>{item.Site}</th>
                    <th>{item.ExamType}</th>
                    <th>{item.StartDate}</th>
                    <th>{item.EndDate}</th>
                    <th>{item.ExpireDate}</th>
                    <th> <button onClick={() => this.onDeleteClick(item._id)} className="btn btn-danger" >Delete</button> </th>
                  </tr>
                )
              })}

            </tbody>
          </Table>

        </div>

        {/* </CardBody>
        
            </Card>
            </Col>
          </Row>
        
        
          </Container> */}
      </div>


    )
  }
}

RequestsList.propTypes = {
  getItems: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
  item: state.item
})

export default connect(
  mapStateToProps,
  { getItems, deleteItem, increaseItem, decreaseItem, getItemsById }
)(RequestsList);
